import { render, staticRenderFns } from "./GoodsDetails.vue?vue&type=template&id=5e994698&"
import script from "./GoodsDetails.vue?vue&type=script&lang=js&"
export * from "./GoodsDetails.vue?vue&type=script&lang=js&"
import style0 from "./GoodsDetails.vue?vue&type=style&index=0&id=5e994698&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports